import { client } from "~/openapi/client.gen";
import Axios from 'axios';

export default defineNuxtPlugin(nuxtApp => {

    const i18n = nuxtApp.$i18n as any;
    const config = useRuntimeConfig();

    Axios.defaults.headers.common = { 'Accept-Language': i18n.locale.value };

    client.setConfig({
        baseURL: config.public.apiPath,
        headers: {
            common: {
                'Accept-Language': i18n.locale.value
            }
        }
    });
    
});